import templateCompiler from './template.art';
import { 
  CONVERT_MAP 
} from "../constants/fw.convert.constants";
const template = templateCompiler(CONVERT_MAP);
export default function ConvertModule() {
    //let callbacks = bindCallbacks(CONVERT_LIST, callback);
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
        {
            // 向末尾追加控件
            action: ACTIONS.AFTER,
            // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
            target: 'home-tab',
            // 定义控件的以及图标，文字等信息
            template: '<gtab text="phantom_online:toolbar.tabs.convert.title" name="convert-tab" group="toolbar-tab" body="fv--fw-convert-tab-paddle"></gtab>',
        },
        {
            action: ACTIONS.APPEND,
            target: 'toolbar-tab-bodies',
            template: template,
        },
    ];
    return {fragments};
}
